import api from "./api";

// ── Stats ────────────────────────────────────────────────────────────────────
export const getOpsStats = () =>
  api.get("/operations/stats/");

// ── My Organisation (Ops Manager) ─────────────────────────────────────────────
export const getMyOrganisation = () =>
  api.get("/operations/my-organisation/");

// ── Organisation CRUD (System Admin) ─────────────────────────────────────────
export const listOrgs = () =>
  api.get("/operations/organisations/");

export const getOrg = (id) =>
  api.get(`/operations/organisations/${id}/`);

export const createOrg = (data) =>
  api.post("/operations/organisations/", data);

export const updateOrg = (id, data) =>
  api.patch(`/operations/organisations/${id}/`, data);

export const deactivateOrg = (id) =>
  api.post(`/operations/organisations/${id}/deactivate/`);

export const getOrgStats = (id) =>
  api.get(`/operations/organisations/${id}/stats/`);

// ── Patient Management ───────────────────────────────────────────────────────
export const listOpsPatients = (params = {}) =>
  api.get("/operations/patients/", { params });

export const getOpsPatient = (id) =>
  api.get(`/operations/patients/${id}/`);

export const enrollOpsPatient = (data) =>
  api.post("/operations/patients/enroll/", data);

export const activateOpsPatient = (id) =>
  api.patch(`/operations/patients/${id}/activate/`);

export const deactivateOpsPatient = (id) =>
  api.patch(`/operations/patients/${id}/deactivate/`);

export const verifyPatientId = (id) =>
  api.post(`/operations/patients/${id}/verify-id/`);

export const unverifyPatientId = (id) =>
  api.post(`/operations/patients/${id}/unverify-id/`);

export const resetPatientPassword = (id) =>
  api.post(`/operations/patients/${id}/reset-password/`);

// ── Provider Management ──────────────────────────────────────────────────────
export const registerOpsProvider = (data) =>
  api.post("/operations/providers/register/", data);

export const listOpsProviders = (params = {}) =>
  api.get("/operations/providers/", { params });

export const getOpsProvider = (id) =>
  api.get(`/operations/providers/${id}/`);

export const activateOpsProvider = (id) =>
  api.patch(`/operations/providers/${id}/activate/`);

export const deactivateOpsProvider = (id) =>
  api.patch(`/operations/providers/${id}/deactivate/`);

export const approveOpsProvider = (id) =>
  api.post(`/operations/providers/${id}/approve/`);

export const resetProviderPassword = (id) =>
  api.post(`/operations/providers/${id}/reset-password/`);

// ── Support Tickets (Ops Manager) ────────────────────────────────────────────
export const listOpsTickets = (params = {}) =>
  api.get("/operations/tickets/", { params });

export const createOpsTicket = (data) =>
  api.post("/operations/tickets/", data);

export const getOpsTicket = (id) =>
  api.get(`/operations/tickets/${id}/`);

export const closeOpsTicket = (id) =>
  api.post(`/operations/tickets/${id}/close/`);

// ── User Inbox (tickets submitted TO this ops manager) ───────────────────────
export const listInboxTickets = (params = {}) =>
  api.get("/operations/tickets/inbox/", { params });

export const respondToTicket = (id, data) =>
  api.post(`/operations/tickets/${id}/respond/`, data);

export const escalateTicket = (id, data) =>
  api.post(`/operations/tickets/${id}/escalate/`, data);

// ── Notifications (Ops Manager) ──────────────────────────────────────────────
export const getOpsNotifications = () =>
  api.get("/operations/notifications/");

export const getOpsNotificationUnreadCount = () =>
  api.get("/operations/notifications/unread-count/");

export const markOpsNotificationsRead = (ids) =>
  api.post("/operations/notifications/mark-read/", { ids });

export const markAllOpsNotificationsRead = () =>
  api.post("/operations/notifications/mark-all-read/");

// ── Billing ──────────────────────────────────────────────────────────────────
export const getOrgBilling = (id, month) =>
  api.get(`/operations/organisations/${id}/billing/`, { params: month ? { month } : {} });

export const getOrgBillingSummary = () =>
  api.get("/operations/organisations/billing-summary/");

// ── Partner Invoices (Admin) ──────────────────────────────────────────────────
export const generateOrgInvoice = (orgId, data) =>
  api.post(`/operations/organisations/${orgId}/generate-invoice/`, data);

export const listOrgInvoices = (orgId) =>
  api.get(`/operations/organisations/${orgId}/invoices/`);

export const markInvoicePaid = (invoiceId) =>
  api.post(`/operations/my-invoices/${invoiceId}/mark-paid/`);

// ── Partner Invoices (Ops Manager) ────────────────────────────────────────────
export const getMyInvoices = () =>
  api.get("/operations/my-invoices/");

export const getMyInvoice = (invoiceId) =>
  api.get(`/operations/my-invoices/${invoiceId}/`);

// ── Hospitals ─────────────────────────────────────────────────────────────────
export const listHospitals = () =>
  api.get("/operations/hospitals/");

export const createHospital = (data) =>
  api.post("/operations/hospitals/", data);

export const updateHospital = (id, data) =>
  api.patch(`/operations/hospitals/${id}/`, data);

export const getHospitalDoctors = (id) =>
  api.get(`/operations/hospitals/${id}/doctors/`);

export const assignDoctorToHospital = (hospitalId, doctorId) =>
  api.post(`/operations/hospitals/${hospitalId}/assign-doctor/`, { doctor_id: doctorId });

export const removeDoctorFromHospital = (hospitalId, doctorId) =>
  api.post(`/operations/hospitals/${hospitalId}/remove-doctor/`, { doctor_id: doctorId });

// ── Network Directory (public) ────────────────────────────────────────────────
export const getNetworkHospitals = () =>
  api.get("/operations/network/hospitals/");

export const getNetworkDoctors = () =>
  api.get("/operations/network/doctors/");

// ── Database Export ───────────────────────────────────────────────────────────
export const exportDatabase = (data = {}) =>
  api.post("/operations/export-database/", data, { responseType: "blob" });

// ── Bulk Registration ─────────────────────────────────────────────────────────
export const downloadBulkTemplate = () =>
  api.get("/operations/bulk-register/template/", { responseType: "blob" });

export const bulkRegisterProviders = (formData) =>
  api.post("/operations/bulk-register/", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
